import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Palette, Brush, Box, Monitor, Smartphone, Layout } from 'lucide-react';

export default function ProductWorkbench() {
  return (
    <SubpageTemplate 
      title="The Workbench"
      subtitle="Visual Synthesis"
      description="The ultimate interface for builders. Edit code, design systems, and preview live deployments in a single unified workspace."
      icon={Box}
      features={[
        {
          title: "Visual Editor",
          description: "Manipulate UI elements directly on the canvas. Changes are reflected in code instantly.",
          icon: Layout
        },
        {
          title: "Design System",
          description: "Manage colors, typography, and component libraries across your entire project with a single source of truth.",
          icon: Palette
        },
        {
          title: "Cross-Device Sync",
          description: "Real-time mobile and tablet previews to ensure your application looks perfect on every screen.",
          icon: Smartphone
        }
      ]}
    />
  );
}
